import { render, staticRenderFns } from "./ColdStorageManage.vue?vue&type=template&id=5f7c4112&scoped=true&"
import script from "./ColdStorageManage.vue?vue&type=script&lang=js&"
export * from "./ColdStorageManage.vue?vue&type=script&lang=js&"
import style0 from "./ColdStorageManage.vue?vue&type=style&index=0&id=5f7c4112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c4112",
  null
  
)

export default component.exports